module.exports = __webpack_public_path__ + "static/media/2_Consideraciones.de7cc702.mp3";